import useEdgeMutation from '@app/data/edge/hooks/useEdgeMutation';
import { useSetRecoilState } from 'recoil';
import { favoritedProductsList } from '../state';
import { UPDATE_FAVORITE_PRODUCTS } from '../mutations';
import type { UpdateFavoriteProductMutation } from '../mutations/__generated__/updateFavoriteProduct.types';
import type { Product } from '../types';

const useFavoriteProduct = (product: Product) => {
  const setProductIsFavorited = useSetRecoilState(favoritedProductsList);

  const { mutatefn, data, error, loading } =
    useEdgeMutation<UpdateFavoriteProductMutation>(UPDATE_FAVORITE_PRODUCTS, {
      onSuccess(data: UpdateFavoriteProductMutation) {
        if (product?.id) {
          const variants = data?.updateListItems?.items?.reduce<
            Record<string, boolean>
          >((acc, value) => {
            if (value?.item?.id) {
              acc[value.item.id] = !!value.item.favorite;
            }

            return acc;
          }, {});

          setProductIsFavorited({ [product?.id]: true, ...variants });
        }
      },
    });

  return {
    data,
    error,
    loading,
    favoriteProduct: mutatefn,
  };
};

export default useFavoriteProduct;
